// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf, anyOf, is, maybe } from "@altostra/type-validations";
import { string, number, boolean, nullValidation } from "@altostra/type-validations/lib/primitives";

export const isEngagementAppGroupIdFeatureLimitationsResult = arrayOf(
  objectOf({
    limit_value: anyOf(number, boolean, string, nullValidation),
    existing_value: maybe(anyOf(number, boolean, string)),
    limit_key: string,
    limit_level: number,
    limit_source: anyOf(is("default"), is("override")),
    status: anyOf(is("error"), is("info"), is("warn")),
  })
);
